/** @param {unknown[][]} rows */
export function downloadCsvMatrix(rows, filename = "bank-transfer-preview.csv") {
  const lines = (rows || []).map((line) =>
    (line || [])
      .map((cell) => {
        if (cell === null || cell === undefined) return "";
        const s = String(cell);
        if (/[",\n\r]/.test(s)) {
          return `"${s.replace(/"/g, '""')}"`;
        }
        return s;
      })
      .join(","),
  );
  const blob = new Blob(["\uFEFF" + lines.join("\r\n")], {
    type: "text/csv;charset=utf-8",
  });
  triggerDownload(blob, filename);
}

export function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
